import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Test } from './socio-emotional-skills-test.models';
import { Answer } from 'aws-sdk/clients/kinesisvideosignalingchannels';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

const TEST_ENDPOINT = 'api/socioEmotionalSkillsTest/student';
const TEST_RESULT_ENDPOINT = 'api/socioEmotionalSkillTestResult';
@Component({
  selector: 'app-socio-emotional-skills-test',
  templateUrl: './socio-emotional-skills-test.component.html',
  styleUrls: ['./socio-emotional-skills-test.component.scss']
})
export class SocioEmotionalSkillsTestComponent implements OnInit {
  test: Test;
  isLoading = false;
  started = false;

  constructor(private apiService: ApiService, private router:Router) { }

  ngOnInit(): void {
    this.loadTest();
  }

  loadTest() {
    this.isLoading = true;
    this.apiService.get({ api: TEST_ENDPOINT }).subscribe(
      (response: Test) => {
        this.test = response;
        this.isLoading = false
      },
      (error) => {
        this.isLoading = false
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un error al cargar el test. Por favor, inténtalo nuevamente.',
        });
      }
    );

  }

  onStartTest() {
    this.started = true;
  }

  onFinishTest(answers: Answer[]) {
    this.isLoading = true;
    this.apiService.post({ api: TEST_RESULT_ENDPOINT, data: { answers } }).subscribe(
      (response) => {
        Swal.fire({
          icon: 'success',
          title: 'Test enviado',
          text: 'Tus respuestas han sido registradas exitosamente.',
          timer: 2500,
          showConfirmButton: false,
        });
        this.router.navigate(['/socio-emotional-skills-test/results']);
        this.isLoading = false;
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un error al enviar el test. Por favor, inténtalo nuevamente.',
        });
        this.isLoading = false;
      },
    );
  }
}
